// removed by extract-text-webpack-plugin
module.exports = {"numberInfo":"antd-pro-numberInfo","suffix":"antd-pro-suffix","numberInfoTitle":"antd-pro-numberInfoTitle","numberInfoSubTitle":"antd-pro-numberInfoSubTitle","numberInfoValue":"antd-pro-numberInfoValue","subTotal":"antd-pro-subTotal","numberInfolight":"antd-pro-numberInfolight"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NumberInfo/index.less
// module id = 377
// module chunks = 0 1